import {TDBaseShape, TDShapeType} from '@modules/whiteboard'
import {TLShape} from '@tldraw/core'

export interface SelectedShapesTitleShape extends TDBaseShape {
  type: 'selectedShapesTitle'
  size: number[]
}

export * from './SelectedShapesTitle'
export * from './SelectedShapesTitleComponent'




// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/selectedShapesCombinedTitle/index.ts